import React from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import DefaultLayout from 'components/layout/DefaultLayout';
import DefaultTabs from 'components/tab/DefaultTabs';
import AppInformationView from './app/AppInformationView';
import ClientView from './app/client/ClientView';
import { useTranslation } from 'react-i18next';
/**
 * * 패키지 관리 - 상세 (탭 컴포넌트 붙이기)
 */

const PackageDetailPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const handleTabClick = (activeKey) => {
    // console.log(activeKey);
  };

  const PackageDetailMenu = [
    {
      key: 'app',
      tab: t('packageIDAppInformation.tabs.app'),
      children: [
        {
          key: 'appInformation',
          tab: t(
            'packageIDAppInformation.tabs.appContents.tabPane.appInformation',
          ),
          table: (
            <AppInformationView appInformation={location?.state?.record} />
          ),
        },
        {
          key: 'client',
          tab: t('packageIDAppInformation.tabs.appContents.tabPane.client'),
          table: <ClientView />,
        },
      ],
    },
    // {
    //   key: 'operationPack',
    //   tab: '운영',
    //   children: [
    //     {
    //       key: 'examine',
    //       tab: '점검',
    //       table: <p>sssss</p>,
    //     },
    //     {
    //       key: 'noticePack',
    //       tab: '공지',
    //       table: <p>rhdll</p>,
    //     },
    //   ],
    // },
  ];
  return (
    <DefaultLayout>
      <DefaultTabs type='line' onChange={handleTabClick}>
        {PackageDetailMenu?.map((v, i) => (
          <Tabs.TabPane key={v.key} tab={v.tab}>
            <DefaultTabs type='card' onChange={handleTabClick}>
              {v?.children?.map((menu) => (
                <Tabs.TabPane key={menu.key} tab={menu.tab}>
                  {menu.table}
                </Tabs.TabPane>
              ))}
            </DefaultTabs>
          </Tabs.TabPane>
        ))}
      </DefaultTabs>
    </DefaultLayout>
  );
};

export default PackageDetailPage;
